import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUnarchiv: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"unarchiv, unbox"} maskId="square-filled-radius-0-stroke-1-IconUnarchiv"><path fillRule="evenodd" clipRule="evenodd" d="M10.2042 2.56412L4.88102 7.0001H19.119L13.7958 2.56412L14.436 1.7959L21 7.26591V21.0001H3V7.26591L9.56402 1.7959L10.2042 2.56412ZM9 11.0001H15V12.0001H9V11.0001Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconUnarchiv;
